module.exports = __webpack_public_path__ + "img/imagen21.2d249a80.jpg";